import Task from "../../../model2/task/task";
import Event from "../../../model2/event/event";
import ProjectUserFull from "../../../model2/project-user/project-user-full";
import {ReassignmentDataType} from "../@type";
import TasksCollection from "../../../model2/task/collection";
import EventsCollection from "../../../model2/event/collection";
import ProjectUsersFullCollection from "../../../model2/project-user/collection-full";


export default function groupAssignmentsByUser(tasksCollection: TasksCollection, eventsCollection: EventsCollection, projectsCollection: ProjectUsersFullCollection, teamUsers: ID[]): ReassignmentDataType[] {

    const result: any = {};

    tasksCollection.models?.forEach((task: Task) => {
        const assignedToUserId = task.assignedToUserId!;
        const actionRequiredUserId = task.actionRequiredUserId!;

        // Group taskAssignments for assignedToUserId
        if (assignedToUserId === actionRequiredUserId) {
            if (!result[assignedToUserId]) {
                result[assignedToUserId] = {
                    assignedToUserId    : assignedToUserId,
                    taskAssignments     : [],
                    eventAssignments    : [],
                    projectOwner        : []
                };
            }
            result[assignedToUserId].taskAssignments.push(task);
        } else {

            // Group taskAssignments for assignedToUserId
            if (!result[assignedToUserId]) {
                result[assignedToUserId] = {
                    assignedToUserId    : assignedToUserId,
                    taskAssignments     : [],
                    eventAssignments    : [],
                    projectOwner        : []
                };
            }
            result[assignedToUserId].taskAssignments.push(task);

            // Group taskAssignments for actionRequiredUserId
            if (!result[actionRequiredUserId]) {
                result[actionRequiredUserId] = {
                    assignedToUserId    : actionRequiredUserId,
                    taskAssignments     : [],
                    eventAssignments    : [],
                    projectOwner        : []
                };
            }
            result[actionRequiredUserId].taskAssignments.push(task);
        }
    });

    // Group eventAssignments
    eventsCollection.models?.forEach((event: Event) => {
        const userId = event.assignedToUserId!;
        if (!result[userId]) {
            result[userId] = {
                assignedToUserId    : userId,
                taskAssignments     : [],
                eventAssignments    : [],
                projectOwner        : []
            };
        }
        result[userId].eventAssignments.push(event);
    });

    // Group projectOwner by userId
    projectsCollection.models?.forEach((owner: ProjectUserFull) => {
        const userId = owner.userId;
        if (!result[userId]) {
            result[userId] = {
                assignedToUserId    : userId,
                taskAssignments     : [],
                eventAssignments    : [],
                projectOwner        : []
            };
        }
        result[userId].projectOwner.push(owner);
    });

    // Add users without assignments
    return teamUsers.map((userId: ID)=> {
        if (result[userId]) {
            return result[userId]
        } else {
            return {
                assignedToUserId: userId,
                taskAssignments     : [],
                eventAssignments    : [],
                projectOwner        : []
            }
        }
    })

    // return Object.values(result);
}
